import React from "react";
import LocationIcon from "../Icons/LocationIcon";
import TimeIcon from "../Icons/TimeIcon";
import DateIcon from "../Icons/DateIcon";
import ArrowRight from "../Icons/ArrowRight";
import Link from "next/link";
import { format } from "date-fns";

const Item = ({ item }) => {
  return (
    <li className="group rounded-lg flex justify-start flex-col transition-all duration-200 ease-linear delay hover:shadow-item hover:scale-110 hover:bg-white-100">
      <Link
        href={`/?eventSlug=${item?.urlName}&accountSlug=${item?.account?.urlName}`}
        as={`/kirkko/${item?.account?.urlName}/${item?.urlName}`}
      >
        <a>
          <img
            role="img"
            alt={
              "Kuva kirkon" +
              item?.account?.name +
              " tapahtumasta, jota klikkaamalla pääsee tapahtuman omille sivuille."
            }
            className="rounded-lg max-h-full w-full max-h-[118px] object-cover object-bottom transition-all duration-200 ease-linear delay group-hover:rounded-br-none group-hover:rounded-bl-none"
            src={item?.previewImgCDN || "/images/bg1.jpeg"}
          />
          <article className="rounded transition-all transition-all duration-200 ease-linear delay py-2 pr-1 group-hover:pl-4">
            <div className="">
              <h2 className="w-full text-left	">
                <span className="font-bold inline-block transition-all duration-200 ease-linear delay truncate-text two-lines !text-base !leading-[19px] !max-h-[38px] mb-2">
                  {item?.title}
                </span>
              </h2>
              <div className="opacity-0 flex transition-all duration-200 ease-linear delay group-hover:opacity-100 justify-between">
                <div className="text-xs transition-all duration-200 ease-linear delay flex flex-1 justify-start">
                  <div className="flex flex-col w-full">
                    <div className="flex items-center">
                      <LocationIcon />
                      <span className="font-bold text-xxs text-gray pl-2.5">
                        {item?.account?.name}
                      </span>
                    </div>
                    <div className="flex items-center flex-1 justify-between w-full pt-1">
                      <div className="flex items-center flex-1 pr-1">
                        <TimeIcon />
                        <span className="font-bold text-xxs text-gray pl-1 flex-1">
                          {item?.publishingDate &&
                            format(
                              new Date(item?.publishingDate).getTime(),
                              "HH.mm"
                            )}
                        </span>
                      </div>
                      <div className="flex items-center flex-1 pr-1">
                        <DateIcon />
                        <span className="font-bold text-xxs text-gray pl-1 flex-1 pr-1">
                          {item?.publishingDate &&
                            format(
                              new Date(item?.publishingDate).getTime(),
                              "dd.MM.yyyy"
                            )}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="rounded bg-blue flex justify-center items-center self-center ml-6 w-9 h-35 transition-all duration-300 ease-linear delay group-hover:scale-75 p-2.5">
                  <div className="flex justify-center rounded bg-blue self-center text-lg font-bold text-white">
                    <ArrowRight height={10} width={6} />
                  </div>
                </div>
              </div>
            </div>
          </article>
        </a>
      </Link>
    </li>
  );
};

export default Item;
